import { AppBar, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';
import React, { useState } from 'react';
import TabPanel from '../../TabPanel';
import Finishing from './Finishing';
import Inventory from './Inventory';
import ScheduledDelivery from './ScheduledDelivery';
import Sizes from './Sizes';
import SuggestiveProduct from './SuggestiveProduct';

// New Aba
import Whatsapp from '../../../../../newPages/Whatsapp';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    paddingTop: 10,
  },
}));

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Parameters: React.FC = () => {
  const classes_root = useStyles();
  const { subTab } = useParams() as any;

  const [tab, setTab] = useState(() => {
    if (!Number.isNaN(subTab)) {
      return Number(subTab);
    }

    return 0;
  });
  return (
    <div className={classes_root.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="config_tabs"
        >
          <Tab label="Tamanhos" {...a11yProps(0)} />
          <Tab label="Produto Sugestivo" {...a11yProps(1)} />
          <Tab label="Whatsapp" {...a11yProps(2)} />
          <Tab label="Finalização" {...a11yProps(3)} />
          <Tab label="Entrega" {...a11yProps(4)} />
          <Tab label="Estoque" {...a11yProps(5)} />
        </Tabs>
      </AppBar>

      <TabPanel value={tab} index={0}>
        <Sizes />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <SuggestiveProduct />
      </TabPanel>

      <TabPanel value={tab} index={2}>
        <Whatsapp />
      </TabPanel>

      <TabPanel value={tab} index={3}>
        <Finishing />
      </TabPanel>

      <TabPanel value={tab} index={4}>
        <ScheduledDelivery />
      </TabPanel>

      <TabPanel value={tab} index={5}>
        <Inventory />
      </TabPanel>
    </div>
  );
};

export default Parameters;
